import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'

const View = () => {
  const { id } = useParams()
  const [festival, setFestival] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchFestivalData = async () => {
    try {
      const response = await axiosAuthInstance.get(`festival/detail/${id}`)

      console.log('response', response.data.result)
      setFestival(response.data.result)
    } catch (error) {
      console.error('Error fetching festival data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchFestivalData()
  }, [id])

  if (loading) {
    return <div>Loading...</div>
  }

  if (!festival) {
    return <div>No festival data found.</div>
  }

  return (
    <div className='p-4'>
      <div className='bg-white text-black shadow-md rounded-lg p-6'>
        <h2 className='text-xl font-semibold mb-2'>Festival Details</h2>
        <div className='overflow-x-auto'>
          <table className='table-auto w-full border-collapse'>
            <tbody>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>
                  Festival Name
                </td>
                <td className='border-b px-4 py-2'>{festival.festName}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Date</td>
                <td className='border-b px-4 py-2'>
                  {new Date(festival.dateOfPost).toISOString().split('T')[0]}
                </td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>
                  Festival Images
                </td>
                <td className='border-b px-4 py-2'>
                  {festival.festImages.length > 0 ? (
                    <div className='flex flex-wrap gap-2'>
                      {festival.festImages.map((photo, index) => (
                        <img
                          key={index}
                          src={photo}
                          alt={`festival ${index + 1}`}
                          className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                        />
                      ))}
                    </div>
                  ) : (
                    <span>No photos available</span>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default View
